'use client';

import {styled} from "@mui/system";
import {Divider} from "@mui/material";

const CustomDivider = styled(Divider)(({theme}) => ({
    borderColor: theme.palette.custom?.dividerBorderColor,
    backgroundColor: theme.palette.custom?.dividerBorderColor,
    borderBottom: `1px solid ${theme.palette.custom?.dividerBorderBottomColor}`,
    height: '2px !important',
}));

export default CustomDivider;
